/**
 * Document GraphQL Queries
 *
 * 7 queries for document management, versioning, and Chaos-to-DSL integration.
 */

import { gql } from '@apollo/client';
import { DOCUMENT_FIELDS_FRAGMENT, DOCUMENT_VERSION_INFO_FRAGMENT, DOCUMENT_CONNECTION_FRAGMENT } from './fragments';

export const GET_DOCUMENT = gql`
  query GetDocument($tenantId: String!, $documentId: String!) {
    getDocument(tenantId: $tenantId, documentId: $documentId) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const LIST_DOCUMENTS = gql`
  query ListDocuments($tenantId: String!, $limit: Int, $cursor: String) {
    listDocuments(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      ...DocumentConnectionFields
    }
  }
  ${DOCUMENT_CONNECTION_FRAGMENT}
`;

export const GET_DOCUMENTS_BY_TYPE = gql`
  query GetDocumentsByType($tenantId: String!, $documentType: DocumentType!) {
    getDocumentsByType(tenantId: $tenantId, documentType: $documentType) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const GET_DOCUMENTS_BY_STATUS = gql`
  query GetDocumentsByStatus($tenantId: String!, $status: DocumentStatus!) {
    getDocumentsByStatus(tenantId: $tenantId, status: $status) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const GET_DOCUMENTS_PENDING_APPROVAL = gql`
  query GetDocumentsPendingApproval($tenantId: String!, $approverActorId: String) {
    getDocumentsPendingApproval(tenantId: $tenantId, approverActorId: $approverActorId) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;

export const GET_DOCUMENT_VERSION_HISTORY = gql`
  query GetDocumentVersionHistory($tenantId: String!, $documentId: String!) {
    getDocumentVersionHistory(tenantId: $tenantId, documentId: $documentId) {
      ...DocumentVersionInfoFields
    }
  }
  ${DOCUMENT_VERSION_INFO_FRAGMENT}
`;

export const GET_CHAOS_GENERATED_DOCUMENTS = gql`
  query GetChaosGeneratedDocuments($tenantId: String!) {
    getChaosGeneratedDocuments(tenantId: $tenantId) {
      ...DocumentFields
    }
  }
  ${DOCUMENT_FIELDS_FRAGMENT}
`;
